<template>
    <div class="NewQCStep4">
        <!--List criteria-->
        <div class="p-12 content-tab fci-scrollbar">
            <!--Options for ASR-->
            <div class="centerY justify-space-between">
                <div class="mb-6 centerY asr-options">
                    <div
                        v-for="itemBtn in asrCriteriaButtons"
                        :key="itemBtn.key"
                        class="chip-criteria"
                        @click="addASRCriteria(itemBtn)"
                    >
                        <img src="/img/add-member.svg" alt="icon-add-asr-criteria">
                        {{ itemBtn.name }}
                    </div>
                </div>
                <div v-if="!isAllowDragOrDrop" class="centerY" style="font-size: 13px; color: #919191;">
                    <v-progress-circular
                        indeterminate
                        color="#919191"
                        style="width: 18px"
                        class="mr-8"
                    ></v-progress-circular>
                    {{ $f.tc('swapInProgress') }}
                </div>
            </div>

            <table class="criteria-table">
                <thead>
                <tr>
                    <th scope="col" class="text-left">{{ this.$f.tc('type') }}</th>
                    <th scope="col" class="text-left">{{ this.$f.tc('name') }}</th>
                    <th scope="col" class="text-left">{{ this.$f.tc('description') }}</th>
                    <th scope="col" class="text-left">{{ this.$f.tc('default') }}</th>
                    <th scope="col">{{ this.$f.tc('required') }}</th>
                    <th></th>
                </tr>
                </thead>
                <tr v-if="showLoadingTable" style="border-top: 1px solid #DADFEC">
                    <td colspan="6" style="height: 40px">
                        <div class="centerXY">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                                style="width: 22px"
                                class="mr-8"
                            ></v-progress-circular>
                            {{ $f.tc('loadingData') }}
                        </div>
                    </td>
                </tr>

                <!--Draggable criteria-->
                <template v-else>
                    <draggable
                        v-if="criteriaList.length > 0"
                        v-model="criteriaList"
                        tag="tbody"
                        :move="onMoveCallback"
                        :clone="onCloneCallback"
                        :disabled="!isAllowDragOrDrop"
                        @end="onDropCallback"
                    >
                        <tr v-for="item in criteriaList" :key="item.name">
                            <td>{{ item.type }}</td>
                            <td>
                                <v-textarea
                                    v-if="item.id === editModel.id"
                                    v-model="editModel.name"
                                    class="textarea-custom"
                                    :rows="2"
                                    :rules="formRules.required"
                                ></v-textarea>
                                <v-textarea
                                    v-else
                                    v-model="item.name"
                                    :rows="2"
                                    class="textarea-custom"
                                    readonly
                                ></v-textarea>
                            </td>
                            <td>
                                <v-textarea
                                    v-if="item.id === editModel.id"
                                    v-model="editModel.description"
                                    class="textarea-custom"
                                    :rows="2"
                                ></v-textarea>
                                <v-textarea
                                    v-else
                                    v-model="item.description"
                                    :rows="2"
                                    class="textarea-custom"
                                    readonly
                                ></v-textarea>
                            </td>
                            <td>
                                <v-select
                                    v-if="item.id === editModel.id && item.type !== 'TEXT'"
                                    :items="JSON.parse(item.config)"
                                    :return-object="false"
                                    v-model="editModel.default_value"
                                    @click:clear="setDefaultValue(editModel, 'default_value', '')"
                                    item-value="value"
                                    item-text="value"
                                    clearable
                                    class="input-custom"
                                ></v-select>
                                <v-textarea
                                    v-if="item.id === editModel.id && item.type === 'TEXT'"
                                    v-model="editModel.default_value"
                                    :rows="2"
                                    class="textarea-custom"
                                ></v-textarea>
                                <v-textarea
                                    v-if="item.id !== editModel.id"
                                    v-model="item.default_value"
                                    :rows="2"
                                    class="textarea-custom"
                                    readonly
                                ></v-textarea>
                            </td>
                            <td>
                                <v-checkbox
                                    v-if="item.id === editModel.id"
                                    v-model="editModel['is_required']"
                                    color="#0052CC"
                                    :hide-details="true"
                                    style="margin-left: 27px"
                                ></v-checkbox>
                                <v-checkbox
                                    v-else
                                    v-model="item['is_required']"
                                    :hide-details="true"
                                    style="margin-left: 27px"
                                    disabled
                                ></v-checkbox>
                            </td>
                            <td>
                                <div v-if="item.id === editModel.id" class="centerXY">
                                    <div @click="closeEdit" class="btn-icon mr-6">
                                        <img src="/img/close.svg" alt="icon-config" style="transform: scale(1.3)">
                                    </div>
                                    <div @click="saveEdit(item)" class="btn-icon">
                                        <img src="/img/save-member-2.svg" alt="icon-config"
                                             style="transform: scale(0.9)">
                                    </div>
                                </div>
                                <div v-else class="centerXY">
                                    <div class="btn-icon mr-1" v-if="item.type === 'ENUM'"
                                         @click="openCriteriaConfig(item)">
                                        <img src="/img/config.svg" alt="icon-config" style="transform: scale(0.9)">
                                    </div>
                                    <div
                                        class="btn-icon mr-1"
                                        @click="editCriteriaItem(item)"
                                        v-if="!asrCriteriaButtons.find(i => i.name.toLowerCase() === item.name.trim().toLowerCase())"
                                    >
                                        <img src="/img/edit-2.svg" alt="icon-edit" style="transform: scale(0.9)">
                                    </div>
                                    <div class="btn-icon" @click="deleteCriteriaItem(item)">
                                        <img src="/img/delete-new.svg" alt="icon-delete" style="transform: scale(0.9)">
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </draggable>
                    <tr v-else style="border-top: 1px solid #DADFEC">
                        <td colspan="6" style="height: 40px">
                            <div class="centerXY">
                                {{ $f.tc('noDataAvailable') }}
                            </div>
                        </td>
                    </tr>
                </template>
            </table>

            <!--Add new criteria-->
            <div
                class="btn-custom-normal"
                @click="handleClickAddNew"
                style="border-top: none;"
                v-show="!isShowAddItem && !showLoadingTable"
            >
                <img src="/img/add-member.svg" alt="icon-add" style="padding-right: 6px">
                {{ $f.tc('addNew') }}
            </div>
            <v-form v-show="isShowAddItem" class="table-add-member" v-model="formValid"
                    ref="form">
                <div class="item-new-member centerXY">
                    <v-select
                        v-model="model.type"
                        :rules="formRules.required"
                        :items="typeOptions"
                        item-value="value"
                        item-text="name"
                        class="input-custom"
                    ></v-select>
                </div>
                <div class="item-new-member centerXY">
                    <v-textarea v-model="model.name" class="textarea-custom" :rows="2"
                                :rules="formRules.required" ref="NewCriteriaName"></v-textarea>
                </div>
                <div class="item-new-member">
                    <v-textarea v-model="model.description" class="textarea-custom" :rows="2"></v-textarea>
                </div>
                <div class="item-new-member">
                    <v-textarea v-if="model.type==='TEXT'" v-model="model.default_value" class="textarea-custom"
                                :rows="2"></v-textarea>
                    <v-select
                        v-else
                        :items="model.type==='BOOL'?['correct','wrong']:[]"
                        v-model="model.default_value"
                        clearable
                        class="input-custom"
                    ></v-select>
                </div>
                <div class="item-new-member">
                    <v-checkbox
                        v-model="model.required"
                        color="#0052CC"
                        :hide-details="true"
                        style="margin-left: 37px"
                    ></v-checkbox>
                </div>

                <div class="item-new-member">
                    <div @click="cancelAddCriteria" class="btn-icon mr-6">
                        <img src="/img/close.svg" alt="icon-config" style="transform: scale(1.3)">
                    </div>
                    <div @click="submit" class="btn-icon">
                        <img src="/img/save-member-2.svg" alt="icon-config" style="transform: scale(0.9)">
                    </div>
                </div>
            </v-form>
        </div>

        <!--Footer-->
        <div class="dialog-footer justify-center" v-if="!hideFooter">
            <div class="btn-primary btn-back" @click="backStep">
                <img class="mr-12" src="/img/arrow-right.svg" alt="icon-back" style="transform: rotate(180deg)">
                {{ $f.tc('back') }}
            </div>
            <div class="btn-primary" @click="done">
                {{ $f.tc('done') }}
                <img class="ml-12" src="/img/arrow-right.svg" alt="icon-next">
            </div>
        </div>
        <CriteriaConfigEditor ref="CriteriaConfigEditor" :isQCSentence="true"
                              @isChangeEnumConfig="changeEnumConfig"></CriteriaConfigEditor>
    </div>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import { mapState } from 'vuex'
import QcCampaignService from '@/services/qc.campaign.service'
import CriteriaConfigEditor from '@/views/QualityControl/Dialog/CriteriaConfigEditor'
import draggable from 'vuedraggable'
import lodash from 'lodash'

const typeOptions = [
    { name: 'BOOL', value: 'BOOL' },
    { name: 'ENUM', value: 'ENUM' },
    { name: 'TEXT', value: 'TEXT' }
]

const defaultModel = {
    type: 'BOOL',
    name: '',
    description: '',
    required: true,
    default_value: '',
}

export default {
    name: 'NewQCStep4',
    components: { CriteriaConfigEditor, draggable },
    mixins: [
        FormMixin,
        RoleMixin
    ],
    props: {
        hideFooter: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            typeOptions,
            asrOptions: [],
            showLoadingTable: false,
            isAllowDragOrDrop: true,
            showConfirmOverlay: false,
            criteriaToDelete: false,
            criteriaToConfig: false,
            isShowAddItem: false,
            model: this.$utils.cloneObject(defaultModel),
            editModel: {},
            editModelIndex: -1,
            dragFrom: {},
            dragTo: {},
        }
    },
    computed: {
        ...mapState({
            isEdit: state => state.campaign.isEdit,
            qcCampaign: state => state.qccampaign.campaign
        }),
        headers () {
            return [
                {
                    text: this.$f.tc('type'),
                    value: 'type'
                },
                {
                    text: this.$f.tc('name'),
                    value: 'name',
                    type: 'custom',
                    id: 'name'
                },
                {
                    text: this.$f.tc('description'),
                    value: 'description',
                    type: 'custom',
                    id: 'description'
                },
                {
                    text: this.$f.tc('default'),
                    value: 'default_value',
                    type: 'custom',
                    id: 'default_value'
                },
                {
                    text: this.$f.tc('required'),
                    value: 'is_required',
                    type: 'custom',
                    id: 'is_required'
                },

                {
                    text: '',
                    value: 'action',
                    sortable: false,
                    type: 'custom',
                    id: 'action'
                }
            ]
        },
        asrCriteriaButtons () {
            return [
                {
                    key: 'sttCriteria',
                    name: 'STT Criteria',
                    description: 'STT Criteria',
                    required: true
                },
                {
                    key: 'nlpCriteria',
                    name: 'NLP Criteria',
                    description: 'NLP Criteria',
                    required: true
                },
            ]
        },
        criteriaList () {
            return this.qcCampaign ? this.qcCampaign['asr_criteria'] : []
        }
    },
    mounted () {
        this.getCriteria()
    },
    methods: {
        getCriteria () {
            if (this.qcCampaign) {
                this.showLoadingTable = true
                return QcCampaignService.ASRCriteriaService.search(this.qcCampaign.id).then(result => {
                    this.$store.commit(this.$actionTypes.qccampaign.UPDATE_ASR_CRITERIA, result.data)
                    this.updateAsrCriteria(result.data)
                    if (this.isShowAddItem) {
                        this.model = this.$utils.cloneObject(defaultModel)
                        this.isShowAddItem = false
                    }
                }).finally(() => this.showLoadingTable = false)
            }
        },
        createCriteria (newCriteria) {
            this.showLoadingTable = true
            QcCampaignService.ASRCriteriaService.create(this.qcCampaign.id, newCriteria).then(async () => {
                await this.getCriteria()
            }).finally(() => this.showLoadingTable = false)
        },
        deleteCriteriaItem (item) {
            let deleteMessage = this.$f.tc('delete') + ' ' + this.$t('criteria') + ' ' + item.name
            const i18n = {
                action: this.$f.tc('delete'),
                item: this.$t('criteria')
            }
            this.$appService.confirm(deleteMessage).then(
                confirm => {
                    if (confirm) {
                        this.showLoadingTable = true
                        QcCampaignService.ASRCriteriaService.delete(this.qcCampaign.id, item.id).then(
                            async () => {
                                this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                                this.itemToDelete = false
                                await this.getCriteria()
                            }
                        ).finally(() => this.showLoadingTable = false)
                    }
                }
            )
        },
        submit (event) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                if (!this.model.required) {
                    this.model.required = false
                }

                let newCriteria = this.$utils.cloneObject(this.model)
                delete newCriteria.required
                newCriteria.is_required = this.model.required
                this.createCriteria(newCriteria)
            } else {
                this.$refs.form.validate()
            }
        },
        editCriteriaItem (item) {
            this.editModelIndex = this.criteriaList.indexOf(item)
            this.editModel = Object.assign({}, item)
        },
        cancelAddCriteria () {
            this.isShowAddItem = false
            this.$refs.form.resetValidation()
            this.model = this.$utils.cloneObject(defaultModel)
        },
        backStep () {
            this.$emit('backStep')
        },
        done () {
            if (!this.isEdit) {
                this.$router.push('/qc-campaign/' + this.qcCampaign.id)
            }
        },
        openCriteriaConfig (item) {
            this.$refs.CriteriaConfigEditor.open(this.qcCampaign.id, item.id)
        },
        closeEdit () {
            this.editModel = {}
            this.editModelIndex = -1
        },
        saveEdit (item) {
            if (lodash.isEqual(this.editModel, item)) {
                this.closeEdit()
                return
            }

            if (this.editModelIndex > -1) {
                this.showLoadingTable = true
                QcCampaignService.ASRCriteriaService.replace(this.qcCampaign.id, this.editModel.id, this.editModel).then(() => {
                    this.getCriteria()
                }).finally(() => this.showLoadingTable = false)
            }

            this.closeEdit()
        },
        addASRCriteria (item) {
            const asrCriteriaExistIdx = this.criteriaList.findIndex(i => i.name === item.name)
            if (asrCriteriaExistIdx > -1) {
                this.$appService.toastError(this.$t('formRules.fieldDuplicate'))
                return
            }

            this.createCriteria({
                type: 'TEXT',
                name: item.name,
                description: item.description,
                is_required: item.required,
            })
        },
        handleClickAddNew () {
            this.isShowAddItem = true
            this.$nextTick(() => {
                this.$refs.NewCriteriaName.focus()
            })
        },

        // Methods for drag and drop
        onCloneCallback (item) {
            return this.$utils.cloneObject(item)
        },
        onMoveCallback (evt) {
            this.dragFrom = evt.draggedContext.element
            this.dragTo = evt.relatedContext.element
            return !this.dragFrom.locked
        },
        onDropCallback () {
            if (this.dragFrom.id === this.dragTo.id) {
                return
            }

            let model = {
                'old_id': this.dragFrom.id,
                'new_id': this.dragTo.id,
            }
            this.isAllowDragOrDrop = false
            QcCampaignService.swapASRCriteria(this.qcCampaign.id, model).then(() => {
                this.getCriteria()
            }).finally(() => this.isAllowDragOrDrop = true)
        },
        updateAsrCriteria (data) {
            this.$emit('updateAsrCriteria', data)
        },
        changeEnumConfig (data) {
            if (data) {
                this.getCriteria()
            }
        },

    },
}
</script>
<style scoped lang="scss">
.campaign-info {
    display: block;
    margin: 0 auto;
    width: 100%;
    max-width: 1080px;
}

.campaign-form {
    display: flex;
    flex-direction: column;
    align-items: center;

    .label {
        font-family: "open sans semi", serif;
        margin-bottom: 6px;
        font-size: 13px;
    }
}

.btn-custom-normal {
    height: 40px !important;
    border-radius: 0 !important;
    justify-content: left;
    color: #0052CC;
    font-size: 14px;
    font-family: "open sans bold", serif;
    font-style: normal;
    text-align: center;
}

.btn-back {
    margin-right: 8px;
}

.textarea-custom {
    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 0;
            outline: none;
            font-size: 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 40px;
            background: #FFFFFF;
            border-radius: 0;
            border: none !important;
            outline: none;
            font-size: 14px;
            padding: 0 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.table-add-member {
    border: 1px solid #DADFEC;
    display: flex;
    border-top: none;

    .item-new-member {
        border-right: 1px solid #DADFEC;

        &:last-child {
            border-right: none;
        }

        &:nth-child(1) {
            width: 120px;
        }

        &:nth-child(2) {
            width: 200px;
        }

        &:nth-child(3) {
            flex: 1;
            padding: 0;
        }

        &:nth-child(4), &:nth-child(5), &:nth-child(6) {
            margin: 0 !important;
            align-items: center;
            justify-content: center;
            display: flex;
        }

        &:nth-child(4) {
            width: 200px;
        }

        &:nth-child(5) {
            width: 100px;
        }

        &:nth-child(6) {
            width: 119px;
        }
    }
}

.asr-options {
    gap: 6px;
    
    .chip-criteria {
        border: 1px solid #0052CC;
        padding: 3px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        cursor: pointer;
        color: #0052CC;
        user-select: none;

        img {
            width: 10px;
            margin-right: 6px;
        }

        &:hover {
            background: #e4edfa;
        }
    }
}

::v-deep {
    .v-input--selection-controls {
        margin-left: 10px !important;
        margin-top: 0 !important;
        padding-top: 0 !important;
        justify-content: center !important;
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input__control {
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 10px !important;
        top: 14px !important;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }

    .criteria-table {
        width: 100%;
        font-size: 14px;
        font-family: "open sans", serif !important;
        border: 1px solid #DADFEC;
        border-collapse: collapse;
        border-spacing: 0;

        thead tr:not(.v-datatable__progress) {
            height: 40px !important;
            border-bottom: none;
            padding: 0 !important;

        }

        thead tr th {
            text-transform: capitalize !important;
            color: #12274F !important;
            background: #F4F7FE;
            border-right: 1px solid #DADFEC;
            padding: 0 10px;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 120px;
            }

            &:nth-child(2) {
                width: 200px;
            }

            &:nth-child(3) {
                flex: 1;
            }

            &:nth-child(4) {
                width: 200px;
            }

            &:nth-child(5) {
                width: 100px;
            }

            &:nth-child(6) {
                width: 120px;
            }
        }

        tbody tr td {
            height: 40px !important;
            border-right: 1px solid #DADFEC;
            padding: 0 10px;
            border-top: 1px solid #DADFEC;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 120px;
            }

            &:nth-child(2) {
                width: 200px;
                padding: 0;
            }

            &:nth-child(3) {
                flex: 1;
                padding: 0;
            }

            &:nth-child(4) {
                width: 200px;
            }

            &:nth-child(5) {
                width: 100px;
            }

            &:nth-child(6) {
                width: 120px;
            }
        }
    }
}
</style>
